import {ThemeOptions} from '@mui/material';

import {Tokens} from '../../../types/generated/Tokens';

export const palette = (
  paletteTokens: Tokens['palette'],
  iconTokens: Tokens['icon'],
  extraColorsTokens: Tokens['extraColors']
): ThemeOptions['palette'] => ({
  primary: {
    main: paletteTokens.primary.main,
    light: paletteTokens.primary.light,
    dark: paletteTokens.primary.dark
  },
  secondary: {
    main: paletteTokens.secondary.main,
    light: paletteTokens.secondary.light,
    dark: paletteTokens.secondary.dark
  },
  error: {
    main: paletteTokens.error.main,
    light: paletteTokens.error.light,
    dark: paletteTokens.error.dark
  },
  warning: {
    main: paletteTokens.warning.main,
    light: paletteTokens.warning.light,
    dark: paletteTokens.warning.dark
  },
  info: {
    main: paletteTokens.tint.info,
    light: paletteTokens.neutral[2],
    dark: paletteTokens.neutral[5]
  },
  success: {
    main: paletteTokens.success.main,
    light: paletteTokens.success.light,
    dark: paletteTokens.success.dark
  },
  grey: {
    50: paletteTokens.neutral[2],
    100: paletteTokens.neutral[5],
    200: paletteTokens.neutral[10],
    300: paletteTokens.neutral[20],
    400: paletteTokens.neutral[30],
    500: paletteTokens.neutral[42],
    600: paletteTokens.neutral[56],
    700: paletteTokens.neutral[70],
    800: paletteTokens.neutral[80],
    900: paletteTokens.neutral[90]
  },
  text: {
    primary: paletteTokens.text.primary,
    secondary: paletteTokens.text.secondary,
    disabled: paletteTokens.text.disabled,
    hint: paletteTokens.text.hint,
    onAccent: paletteTokens.text.onAccent
  },
  background: {
    paper: paletteTokens.background.paper,
    default: paletteTokens.background.default,
    secondary: paletteTokens.background.secondary,
    gray: paletteTokens.background.gray,
    accent: paletteTokens.background.accent,
    accent2: paletteTokens.background.accent2
  },
  tint: {
    error: paletteTokens.tint.error,
    info: paletteTokens.tint.info,
    alert: paletteTokens.tint.alert,
    success: paletteTokens.tint.success,
    info2: paletteTokens.tint.info2,
    info3: paletteTokens.info.dark
  },
  icon: {
    primary: iconTokens.color.primary,
    secondary: iconTokens.color.secondary
  },
  extraColors: {
    black: extraColorsTokens?.black || '',
    dark: extraColorsTokens?.dark || '',
    darkBlue: extraColorsTokens?.darkBlue || '',
    darkerBlue: extraColorsTokens?.darkerBlue || '',
    darkestBlue: extraColorsTokens?.darkestBlue || '',
    light: extraColorsTokens?.light || '',
    lightGreen: extraColorsTokens?.lightGreen || '',
    warning: extraColorsTokens?.warning || '',
    highlight: extraColorsTokens?.highlight || '',
    navy: extraColorsTokens?.navy || '',
    brand120: extraColorsTokens?.brand120 || '',
    brand90: extraColorsTokens?.brand90 || '',
    activePurple: extraColorsTokens?.activePurple || '',
    brand70: extraColorsTokens?.brand70 || '',
    mediumGray: extraColorsTokens?.mediumGray || '',
    hoverBlue: extraColorsTokens?.hoverBlue || '',
    brand100: extraColorsTokens?.brand100 || ''
  }
});
